import { render, staticRenderFns } from "./AddTeamList.vue?vue&type=template&id=b6c165e2&scoped=true"
import script from "./AddTeamList.vue?vue&type=script&lang=js"
export * from "./AddTeamList.vue?vue&type=script&lang=js"
import style0 from "./AddTeamList.vue?vue&type=style&index=0&id=b6c165e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c165e2",
  null
  
)

export default component.exports